module.exports = __webpack_public_path__ + "img/7.5ba669b9.jpg";